import {FiltersType} from '../types/FiltersType';

const isFilterActive = (value: unknown): boolean => {
  // false value is considered inactive
  if (value === false) {
    return false;
  }
  // empty array is considered inactive
  if (Array.isArray(value) && value.length === 0) {
    return false;
  }
  // empty string is considered inactive
  if (value === '') {
    return false;
  }
  // null or undefined are inactive
  if (value === null || value === undefined) {
    return false;
  }
  // any other value (non-empty array, non-empty string, true, object, tuple, etc.) is active
  return true;
};

export const hasSomeFilters = (filters: FiltersType) =>
  Object.entries(filters || {}).some(([key, value]) => {
    // helpers should not be considered
    if (['isMarginAbsolute', 'isPowerInKW', 'priceRangeVersion'].includes(key)) {
      return false;
    }
    // address and radius are handled separately
    if (key === 'address' || key === 'radius') {
      return false;
    }
    return isFilterActive(value);
  }) ||
  // address and radius has to be active together
  (isFilterActive(filters.address) && isFilterActive(filters.radius));
